export function LessonViewSkeleton() {
  return (
    <div className="min-h-screen flex flex-col animate-pulse">
      {/* Mobile top bar */}
      <div className="lg:hidden sticky top-0 z-40 bg-card/95 backdrop-blur-sm border-b border-border px-4 py-3 flex items-center justify-between">
        <div className="h-4 w-16 bg-muted rounded" />
        <div className="flex-1 px-2">
          <div className="h-3 w-24 bg-muted rounded mx-auto mb-1" />
          <div className="h-4 w-32 bg-muted rounded mx-auto" />
        </div>
        <div className="h-9 w-9 rounded-lg bg-muted" />
      </div>

      {/* Mobile progress strip */}
      <div className="lg:hidden px-4 py-2 bg-secondary/30 border-b border-border flex items-center gap-3">
        <div className="h-3 w-10 bg-muted rounded" />
        <div className="flex-1 h-1 bg-muted rounded-full" />
        <div className="h-3 w-8 bg-muted rounded" />
      </div>

      <div className="flex-1 flex flex-col lg:flex-row">
        {/* Sidebar */}
        <aside className="hidden lg:block w-80 bg-card border-r border-border flex-shrink-0 sticky top-0 h-screen overflow-y-auto">
          <div className="p-4 space-y-4">
            <div>
              <div className="h-3 w-24 bg-muted rounded mb-2" />
              <div className="h-1.5 w-full bg-muted rounded-full" />
            </div>
            <div>
              <div className="h-3 w-32 bg-muted rounded mb-2" />
              <div className="h-1.5 w-full bg-muted rounded-full" />
            </div>
            <div className="space-y-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="flex items-center gap-3 px-3 py-2.5 rounded-lg">
                  <div className="w-4 h-4 rounded-full bg-muted" />
                  <div className="flex-1 space-y-1">
                    <div className="h-3 w-32 bg-muted rounded" />
                    <div className="h-2 w-24 bg-muted rounded" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </aside>

        {/* Main content */}
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-8 space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
              <div className="space-y-2">
                <div className="h-4 w-24 bg-muted rounded" />
                <div className="h-6 w-2/3 bg-muted rounded" />
              </div>
              <div className="h-8 w-32 bg-muted rounded-full" />
            </div>
            <div className="aspect-video rounded-xl sm:rounded-2xl overflow-hidden bg-muted" />
            <div className="space-y-3">
              <div className="h-3 w-full bg-muted rounded" />
              <div className="h-3 w-5/6 bg-muted rounded" />
              <div className="h-3 w-4/6 bg-muted rounded" />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

